import { Directive, ElementRef, Input, ViewContainerRef } from "@angular/core";
import { Subscription } from "rxjs";
import { USER_MGMT_CNST } from "../../constants/proj.cnst";
import { AppStateService } from "../../services/app-state.service";
import { DataService } from "../../services/data.service";
import { EnvService } from "../../services/env.service";
import { HttpService } from "../../services/http.service";
import { UtilsService } from "../../services/utils.service";
import { AuthenticationService } from "../authentication/services/authentication.service";

@Directive({
  selector: "[libAppPermissions]",
  standalone: true,
})
export class AppPermissionsDirective {
  @Input("resourceName") resourceName: any;
  @Input("permission") permission: any;
  @Input("location") location?: any;

  currentApplication: any;

  subscriptions: Subscription[] = [];

  userPermissions: any = {};

  constructor(
    private appStateSrv: AppStateService,
    private elementRef: ElementRef,
    private utilSrv: UtilsService,
    private httpSrv: HttpService,
    private dataSrv: DataService,
    private viewContainer: ViewContainerRef,
    private envService: EnvService,
    private authSrv: AuthenticationService
  ) {}

  ngOnInit() {
    this.currentApplication = "App Builder";
    this.viewContainer.clear();

    let hasPermissionsLoaded = this.appStateSrv.getPermissionsLoaded();
    let isPermissionRequestInProcess = this.appStateSrv.getInProcess();

    this.userPermissions = this.appStateSrv.getUserPermissions();

    if (hasPermissionsLoaded) {
      this.checkPermissions();
    } else if (isPermissionRequestInProcess) {
      this.registerCallBack();
    } else {
      const userId = this.authSrv.getUserId();

      if (!userId) {
        this.elementRef.nativeElement.style.display = "none";
        this.viewContainer.clear();
        return;
      }

      this.appStateSrv.setInProcess(true);
      let options = { uriParams: { userId } };
      console.log("fetching user permissions");
      this.httpSrv.makeGetApiCall("GET_USER_PERMISSIONS", this.envService.baseUrl, options).subscribe((res: any) => {
        if (res?.response) {
          this.appStateSrv.setPermissionsLoaded(true);
          this.userPermissions = res.response && res.response.permissions ? res.response.permissions : {};

          let metaInfo = res.response && res.response.meta ? res.response.meta : {};

          this.appStateSrv.setUserMetaInfo(metaInfo);
          this.appStateSrv.setUserPermissionsRef(this.userPermissions);
          this.checkPermissions();

          let currentResourceName = this.appStateSrv.getCurrentResourceName();

          if (currentResourceName === "LOGIN") {
            this.appStateSrv.setCurrentResourceName("USER");
            this.dataSrv.getRoleAndRedirect();
          }
        } else {
          this.utilSrv.showToastMessage("User Not Found", "error");
        }
      });
    }

    const userPermissionsRef = this.appStateSrv.userPermissionsRef.subscribe((response: any) => {
      this.userPermissions = { ...response };
    });

    this.subscriptions.push(userPermissionsRef);
  }

  registerCallBack() {
    const permissionsRef = this.appStateSrv.userPermissionsRef.subscribe((response: any) => {
      this.userPermissions = response;
      permissionsRef.unsubscribe();
      this.checkPermissions();
    });
  }

  checkPermissions() {
    //*If the directive is checking for actions under a resource
    if (this.permission) {
      this.elementRef.nativeElement.style.display = this.doesResourceHaveValidPermission(
        this.resourceName,
        this.permission
      )
        ? "block"
        : "none";
      this.viewContainer.clear();
    }
    //*Else we are checking if the resource itself exists on the application
    else {
      this.elementRef.nativeElement.style.display = this.doesResourceExistInApplication(this.resourceName)
        ? "block"
        : "none";
      this.viewContainer.clear();
    }

    if (this.location && this.location === "sideMenu") {
      this.elementRef.nativeElement.style.display !== "none"
        ? (this.elementRef.nativeElement.style.display = "flex")
        : (this.elementRef.nativeElement.style.display = "none");
      this.viewContainer.clear();
    }
  }

  doesResourceHaveValidPermission(resourceName: string, permission: string): boolean {
    if (this.currentApplication in this.userPermissions) {
      let resSettings = this.userPermissions[this.currentApplication].resources;
      if (resourceName in resSettings) {
        return resSettings[resourceName].actions.indexOf(permission) !== -1;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  doesResourceExistInApplication(resourceName: string): boolean {
    if (!(this.currentApplication in this.userPermissions)) {
      return false;
    }
    return this.userPermissions[USER_MGMT_CNST.CURRENT_APPLICATION]["resources"][resourceName] ? true : false;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }
}
